import React, { useEffect, useState } from "react";

export default function OtpTimer({ expiry }) {
  const [timeLeft, setTimeLeft] = useState(Number(expiry) || 0);
  useEffect(() => {
    localStorage.expiry = timeLeft
  }, [timeLeft])

  useEffect(() => {
    if (timeLeft <= -10) return;
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);
  if (timeLeft <= -10) {
    return null
  }

  return (
    <div>

      {timeLeft > 0 ? (
        <div style={{ color: "gray" }}>OTP expires in {timeLeft}s</div>
      ) : (
        <div style={{ color: "red" }}>OTP Expired</div>
      )}
    </div>
  );
}